import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../context/AuthContext'; 

const Sidebar = () => {
  const { admin } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);

  // Helper to close sidebar when a link is clicked
  const closeSidebar = () => setIsOpen(false);

  //Function to share app/website link
  const handleShareApp = async () => {
    const shareData = {
      title: 'Darul Uloom Online',
      text: 'Check out Darul Uloom Online for Daily Hadees, Courses, and more!',
      url: window.location.origin,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        closeSidebar();
      } catch (err) {
        console.log('Share failed or dismissed');
      }
    } else {
      // Fallback for desktop: Copy to clipboard
      try {
        await navigator.clipboard.writeText(window.location.origin);
        alert('Link copied to clipboard!');
        closeSidebar();
      } catch (err) {
        console.error('Failed to copy', err);
      }
    }
  };

  return (
    <>
      {/* 1. TOP NAVBAR */}
      <nav 
        className="navbar navbar-dark shadow-sm sticky-top px-3" 
        style={{ backgroundColor: '#004d40', minHeight: '70px', zIndex: 1040 }}
      >
        <div className="d-flex align-items-center w-100">
          <button 
            className="navbar-toggler border-0 me-3" 
            type="button" 
            onClick={() => setIsOpen(true)}
            style={{ outline: 'none', boxShadow: 'none' }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <Link to="/" className="text-decoration-none" onClick={closeSidebar}>
            <div className="d-flex flex-column" style={{ lineHeight: '1', fontFamily: 'Amiri, serif' }}>
              <span className="fw-bold fs-4" style={{ color: '#FFD700' }}>DARUL ULOOM ONLINE</span>
              <span className="fs-6 mt-1 text-white opacity-75">دارالعلوم آن لائن</span>
            </div>
          </Link>
        </div>
      </nav>

      {/* 2. THE SIDEBAR (Offcanvas) */}
      <div 
        className={`offcanvas offcanvas-start ${isOpen ? 'show' : ''}`} 
        tabIndex="-1" 
        style={{ 
          backgroundColor: '#ffffff',
          width: '280px',
          borderRight: '4px solid #004d40',
          /* ✅ FIX: Use transform for smooth exit, keep visibility visible for the duration of the slide */
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.3s ease-in-out',
          visibility: 'visible', 
          zIndex: 1060
        }}
      >
        <div className="offcanvas-header bg-light border-bottom p-4">
          <div className="d-flex align-items-center">
            <img 
              src="/images/logo.png" 
              alt="Logo" 
              width="60" 
              height="60" 
              className="me-3 rounded-circle border border-warning"
              style={{ objectFit: 'cover' }}
            />
            <div>
               <h5 className="mb-0 fw-bold" style={{ color: '#004d40' }}>Menu</h5>
               <small className="text-muted">Darul Uloom</small>
            </div>
          </div>
          <button type="button" className="btn-close text-reset" onClick={closeSidebar}></button>
        </div>

        <div className="offcanvas-body p-0">
          <div className="list-group list-group-flush">
            <Link to="/" className="list-group-item list-group-item-action py-3 fw-bold text-dark custom-sidebar-link" onClick={closeSidebar}>
              <i className="bi bi-house-door-fill me-3" style={{ color: '#004d40' }}></i> Home
            </Link>
            <Link to="/courses" className="list-group-item list-group-item-action py-3 fw-bold text-dark custom-sidebar-link" onClick={closeSidebar}>
              <i className="bi bi-book-half me-3" style={{ color: '#004d40' }}></i> Courses
            </Link>
            <Link to="/admissions" className="list-group-item list-group-item-action py-3 fw-bold text-dark custom-sidebar-link" onClick={closeSidebar}>
              <i className="bi bi-pencil-square me-3" style={{ color: '#004d40' }}></i> Admissions
            </Link>
            <Link to="/notices" className="list-group-item list-group-item-action py-3 fw-bold text-dark custom-sidebar-link" onClick={closeSidebar}>
              <i className="bi bi-megaphone-fill me-3" style={{ color: '#004d40' }}></i> Notice Board
            </Link>
            <Link to="/duas" className="list-group-item list-group-item-action py-3 fw-bold text-dark custom-sidebar-link" onClick={closeSidebar}>
              <i className="fas fa-pray me-3" style={{ color: '#004d40' }}></i> Duas
            </Link>
            <a 
              href="https://whatsapp.com/channel/0029Vb8J4ZVKLaHo7nUgcC3i" 
              target="_blank" 
              rel="noreferrer"
              className="list-group-item list-group-item-action py-3 fw-bold text-dark custom-sidebar-link" 
              onClick={closeSidebar}
            >
              <i className="bi bi-whatsapp me-3" style={{ color: '#25D366' }}></i> WhatsApp Channel
            </a>
            <button 
              className="list-group-item list-group-item-action py-3 fw-bold text-dark border-0 custom-sidebar-link" 
              onClick={handleShareApp}
              style={{ cursor: 'pointer', textAlign: 'left' }}
            >
              <i className="bi bi-share-fill me-3" style={{ color: '#FFD700' }}></i> Share App
            </button>
          </div>
          
          <div className="p-4 mt-3">
            {admin ? (
               <Link to="/admin/dashboard" onClick={closeSidebar} className="btn w-100 fw-bold shadow-sm" style={{ backgroundColor: '#FFD700', color: '#000' }}>
                 <i className="bi bi-speedometer2 me-2"></i> Dashboard
               </Link>
            ) : (
               <Link to="/login" onClick={closeSidebar} className="btn btn-outline-success w-100 fw-bold">
                 <i className="bi bi-box-arrow-in-right me-2"></i> Admin Login
               </Link>
            )}
          </div>
        </div>
      </div>

      {/* 3. DARK OVERLAY (Backdrop) */}
      <div 
        className={`offcanvas-backdrop fade ${isOpen ? 'show' : ''}`} 
        style={{ 
          display: isOpen ? 'block' : 'none', // ✅ Only show when open
          zIndex: 1050 
        }} 
        onClick={closeSidebar}
      ></div>
    </>
  );
};

export default Sidebar;